import router from "@/router";
import i18n from "@/configs/i18n";
import useRouterStore from "@/stores/useRouterStore";
import { useAuthStore } from "@/stores/auth";
import PermissionsV1 from "@/router/permissions/v1";
import { HasPermission } from "@/utils/permisshoinHelper";

export function InitDigitalCompetencyRoutes() {
  if (!useAuthStore().userData) return;

  // Без права на рейтинг не нужны ни маршрут, ни пункт меню: раньше их видел
  // каждый вошедший и получал пустую страницу «Нет данных»
  if (!HasPermission(PermissionsV1["DIGITAL_COMPETENCY.TESTING_RATING"])) return;

  router.addRoute("DefaultLayout", {
    path: "/digital-competency/report",
    name: "digital-competency.report",
    meta: {
      middleware: ["auth", "has_access"],
      accesses: PermissionsV1["DIGITAL_COMPETENCY.TESTING_RATING"],
      accesses_redirect: true,
    },
    component: () => import("@/views/digital-competency/TestingRating.vue"),
  });

  const routeStore = useRouterStore();
  for (const group of routeStore.routes) {
    const attestationsItem = group.children?.find((c) => c.slug === "attestations");
    if (attestationsItem?.children) {
      attestationsItem.children.push({
        // Боковое меню выводит name как есть, шапка - через $t: геттер отдаёт
        // уже переведённую подпись обоим и следует за сменой языка
        get name() {
          return i18n.global.t("digital_competency_assessment");
        },
        slug: "digital-competency-report",
        to: { name: "digital-competency.report" },
      });
      break;
    }
  }
}
